export default {
    'en': 'English',
    'pl': 'Polski',
    'ru': 'Русский',
    'FIWE_FEVER': 'FIWE FEVER',
    'EXPERIENCE': 'Poznaj Justfit EMS na',
    'FIWE': 'FIWE',
    'DATE': 'Warsawa 13.09.2019-15.09.2019. <br> Stoisko Justfit: hala IV. Stoisko 4.20',
    'YOUTUBE_TEXT': 'Obejrzyj wideo na YouTube',
    'SAVE_IT': 'ZAOSZCZĘDŹ 5000 EUR i przynieś błyskawiczny sukces Twojej firmie.',
    'JUSTFIT_LITE_PRICE': 'Najlepszy produkt EMS JustfitPro + z opcją na wielu użytkowników dostępny w cenie systemu przewodowego',
    'CONCEPT': 'JustfitPro+ oznacza nie tylko zakup produktu. Zostaniesz częścią programu mentorskiego Justfit. Będziesz zadowolony z naszego wsparcia zarówno w biznesie, jak i technologii.',
    'SYSTEM': 'JustfitPro + to otwarty system gotowy na opcję dla wielu użytkowników. Przyszłe dodatkowe rozszerzenia pakietu będą oferowane za obniżoną cenę.',
    'SERVICE': 'Zapewniamy polską reprezentację, polską obsługę i polskie wsparcie.',
    'CUSTOMIZED_PRODUCT': 'Uzyskaj konfigurację produktu i konstrukcję biznesową dostosowaną do twoich potrzeb.',
    'APPOINTMENT': 'Pomyśl a swojej przyszłości i spotkaj się z nami, aby doświadczyć świat Justfit na FIWE:',
    'INTERESTED': "Tak, jestem zainteresowany",
    'JUSTFIT_EXPERIENCE': 'Wypróbuj świat Justfit na FIWE:',
    'TRAININGS': '',
    'TRAININGS_TEXT': 'Weź udział w indywidualnym lub grupowym treningu próbnym EMS, które będzie prowadzony przez naszych trenerów co godzinę, między 10:00 a 16:00 przy naszym stoisku nr 4.20 w Hali IV. Zarejestruj się i zabezpiecz swoje miejsce! Link na dole. ',
    'PRESENTATION': '',
    'PRESENTATION_TEXT': 'Zapisz się na osobistą prezentację produktu i poznaj naszą wyjątkową możliwość biznesową. Link na dole. ',
    'FORM_TITLE': 'ZAREZERWÓJ SWOJE SPOTKANIE',
    'FORM_TEXT': 'Wypełnij poniższy formularz, aby zabezpieczyć swoje miejsce na jednym z treningów próbnych Justfit EMS albo poproś o prywatne spotkanie I demonstracje naszego produktu.',
    'CONTACT_TEXT': 'W razie pytań prosimy skontaktować się z nami:',
    'YOUR_NAME': 'Imię i Nazwisko',
    'EMAIL': 'Email',
    'MESSAGE': 'Wiadomość',
    'SUBMIT_TEXT': 'Wyślij',
	"SENT_FORM": "Dziękujemy za rejestrację, zapraszamy!",
    "ERROR_SENT_FORM": "Something went wrong, please try again",
    'TRAINING_TYPE': 'Jestem zainteresowany treningiem próbnym w formie prywatnej lub grupowej',
    'PRESENTATION_TYPE': 'Chciał(a)bym wziąć udział na osobistej prezentacji produktu',
    'PREFERRED_DAY': 'Preferowany dzień spotkania:',
    'DAY_1': 'Piątek 13.09.2019.',
    'DAY_2': 'Sobota 14.09.2019.',
    'DAY_3': 'Niedziela 15.09.2019.',
    'PREFERRED_TIME': 'Preferowany czas spotkania:',
    'TIME_1': 'Od 8:00 do 12:00',
    'TIME_2': 'Od 12:00 do 16:00',
    'TIME_3': 'Od 17:00 – 20:00',
    'AGREE': 'Przeczytałem i akceptuję Oświadczenie o ochronie <a class="font-style-italic font-weight-semibold" target="_blank" href="https://justfitart.com/images/privacypolicy.pdf">praw prywatności</a>',
    'YOU_NEED_TO_AGREE': 'You need to agree the privacy policy',
    'LINK_TO_PRODUCT': 'Kliknij tutaj, aby uzyskać zniżkę na nasze produkty.',
    'JUSTFITPRO_PRICE': 'Wyjątkowa oferta, JustfitPro+ za <span class="font-weight-heavy fs-40">12,500</span> Euro, tylko na FIWE. <br> <span class="font-weight-normal fs-14">(Zaoszczędź 5000 EUR)</span>',
}
